import PropTypes from 'prop-types';

const profileDataShape = PropTypes.shape({
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  mobile: PropTypes.string,
  referralCategory: PropTypes.string,
  referralCategoryDetail: PropTypes.string,
  referralName: PropTypes.string,
  street1: PropTypes.string,
  street2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string,
});

export default profileDataShape;
